<template>
  <!-- 自营专区 -->
  <div>
    <!-- 头部登录 -->
    <HeaderTop ref="shopcar"></HeaderTop>
    <Slider></Slider>
    <!-- 头部搜索和tabs -->
    <!-- <Header-Search :activeName="'supportself'"></Header-Search> -->

    <div class="center">
      <div class="supperHead">
        <div class="supperHead-ziying">
          <!-- <div class="headImg"> -->
          <!-- <img src="@/assets/images/poster.jpg" alt="自营专区图片缺失" /> -->
          <p>自营专区</p>
          <!-- </div> -->
          <div class="search">
            <Input
              v-model="key"
              placeholder="请输入配件编码/配件名称(多配件查询用半角逗号分隔)"
              style="width: 300px"
            ></Input>
            <Button type="primary" @click="searchSupper()">搜索</Button>
          </div>
        </div>
      </div>
      <Searchtop ref="searchTop"></Searchtop>
      <div class="active">
        <div class="left">
          <span>门店：</span>
          <Select
            v-model="searchData.shopId"
            style="width: 140px"
            @on-change="changeShop"
            filterable
          >
            <Option v-for="item in shopList" :value="item.id" :key="item.id">{{
              item.shortName
            }}</Option>
          </Select>
        </div>
        <div class="right">
          <Checkbox v-model="hasGoods" @on-change="hasGoodsChange"
            >只显示有货</Checkbox
          >
          <!-- <Checkbox v-model="isActive" @on-change="isActiveChange"
            >只显示活动</Checkbox
          > -->
        </div>
      </div>
      <!-- 分页 -->
      <div style="display: flex; justify-content: right; margin-top: 10px">
        <Page
          :total="pager.total"
          :current="pager.current"
          :page-size="pager.size"
          size="small"
          :page-size-opts="[30]"
          show-total
          @on-change="changeCurrent"
          @on-page-size-change="changeSize"
        />
        <span
          style="
            line-height: 11px;
            height: 26px;
            padding: 7px 10px;
            border: 1px solid #dcdee2;
            border-radius: 3px;
          "
          >30条/页</span
        >
      </div>
      <!-- 表头 -->
      <Row class="tableHeader" v-if="dataList.length">
        <Col span="1"></Col>
        <Col span="5">基本信息</Col>
        <Col span="3">门店</Col>
        <Col span="3">发货地</Col>
        <Col span="2">库存</Col>
        <Col span="4">价格</Col>
        <Col span="3">购买数量</Col>
        <Col span="3">操作</Col>
      </Row>
      <!-- 内容 -->
      <div class="table">
        <transition-group
          name="more"
          v-bind:css="false"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-if="dataList.length"
        >
          <div
            class="tableCenter"
            v-for="(item, index) in dataList"
            :key="item.id"
          >
            <Row>
              <Col span="1"></Col>
              <div class="mb10">
                <div v-show="item.source">
                  {{ item.source }}
                </div>
              </div>
            </Row>
            <Row>
              <Col span="1">
                <div class="activeBox" v-if="item.type == 1">
                  <span class="iconfont icon-a-zu425"></span>
                  <p>优惠</p>
                </div></Col
              >
              <Col span="5" class="detail">
                <div style="cursor: pointer">
                  <!-- <div class="partType">{{ item.typeName }}</div> -->
                  <div
                    class="partName"
                    @click="goDetails(item)"
                    style="max-width: 200px"
                  >
                    <span class="partType">{{ item.typeName }} </span>
                    {{ item.oeCode }}
                    {{ item.brandName }}
                    {{ item.stdNameJp }}
                    {{ item.direction }}{{ item.oilGrade }}
                  </div>
                </div>

                <div class="oe-p" @mouseleave="closeRelevance(index)">
                  OEM码：
                  <div v-if="item.oemCode === null">--</div>
                  <div v-else>
                    <Tooltip :content=item.oemCode placement="top" :transfer="true" :max-width="200">
                      <span class="ellipsis">{{ item.oemCode }}</span>
                    </Tooltip>
                  </div>
<!--                  <p-->
<!--                    @mouseenter="getRelevance(item.partId, index, item)"-->
<!--                    v-if="item.oemCodes.length"-->
<!--                  >-->
<!--                    {{ item.oemCodes[0]-->
<!--                    }}<i-->
<!--                      class="ivu-icon ivu-icon-ios-arrow-down"-->
<!--                      v-if="item.oemCodes.length > 1"-->
<!--                    ></i>-->
<!--                  </p>-->
<!--                  <div-->
<!--                    class="relevance"-->
<!--                    :tabIndex="1"-->
<!--                    v-if="item.oemCodes.length > 1"-->
<!--                  >-->
<!--                    <div-->
<!--                      class="relevanceBox"-->
<!--                      :class="item.isShow ? 'show' : ''"-->
<!--                    >-->
<!--                      &lt;!&ndash; 关联原厂件号： &ndash;&gt;-->
<!--                      <p v-for="i in item.oemCodes.slice(1)" :key="i">-->
<!--                        {{ i }}-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
                </div>
                <ul style="padding-left: 4px">
                  <li>服务：</li>
                  <li v-if="item.genuineGuarantee">
                    <span class="iconfont icon-a-lujing153"></span>
                    <!-- <p>正品保证</p> -->
                  </li>
                  <li v-if="item.technicalSupport">
                    <!-- <li> -->
                    <span class="iconfont icon-a-ziyuan4"></span>
                    <!-- <p>技术支持</p> -->
                  </li>
                  <br />
                  <li v-if="item.warrantyService">
                    <!-- <li> -->
                    <span class="iconfont icon-a-ziyuan5"></span>
                    <!-- <p>保修服务</p> -->
                  </li>

                  <li v-if="item.returnPromise">
                    <!-- <li> -->
                    <span class="iconfont icon-a-ziyuan21"></span>
                    <!-- <p>退换货承诺</p> -->
                  </li>
                </ul>
              </Col>
              <!-- 门店 -->
              <Col span="3" class="flexCenter">
                <div class="shop">
                  <!-- 这期隐藏不跳转 -->
                  <p @click="goShop(item)" style="cursor: pointer">
                    {{ item.shopName }}
                  </p>
                  <!-- <p style="cursor: pointer">
                    {{ item.shopName }}
                  </p> -->
                  <span>{{ item.provinceName }}{{ item.cityName }}</span>
                </div>
              </Col>
              <!-- 发货地 -->
              <Col span="3" class="w120">
                <div class="oe-p" @mouseleave="closeCity(index)">
                  <p
                    class="w122"
                    @mouseenter="getCity(item.partId, index, item)"
                    v-if="item.shipCityStores.length"
                  >
                    {{ item.shipCityStore.city }}
                    {{ item.shipCityStore.name }}
                    <i
                      class="ivu-icon ivu-icon-ios-arrow-down"
                      v-if="item.shipCityStores.length > 1"
                    ></i>
                  </p>
                  <div
                    class="relevance"
                    :tabIndex="1"
                    v-if="item.shipCityStores.length > 1"
                  >
                    <div
                      class="relevanceBox w33"
                      :class="item.isShows ? 'show' : ''"
                    >
                      <p
                        v-for="i in item.shipCityStores"
                        :key="i.storeId"
                        class="w22"
                        :class="isCity === i.name ? 'isCityed' : ''"
                        @click="checkCITY(i, item)"
                      >
                        {{ i.city }}
                        {{ i.name }}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span="2" class="flexCenter" style="font-size: 18px;color: #f55414"
                >{{ item.stock > 0 ? '有货' : '售空' }}
                </Col
              >
              <Col span="4"
                ><div class="price">
                  <div v-if="!item.inquiry || (item.shopId==='1483461070799147008'&&item.minPrice !=='0.00'&&item.carBrandName==='Asanetwork(艾森沃克)')">
                    <!-- <div> -->
                    <p>￥{{ item.price }}</p>
                    <span
                      v-if="item.type == 1"
                      class="iconfont icon-a-lujing156"
                    ></span>
                    <span v-if="item.type == 1">{{ item.activityTime }}</span>
                  </div>
                  <p v-else>询价</p>
                </div>
              </Col>
              <Col span="3">
                <div class="number">
                  <div class="number-sp" :class="item.isNumber ? 'show' : ''">
                    库存不足
                  </div>
                  <div
                    class="number-in"
                    style="border: 1px solid #dcdee2; border-radius: 4px"
                  >
                    <Button
                      style="
                        border: none;
                        border-right: 1px solid #dcdee2;
                        border-radius: 0;
                      "
                      class="number-sub"
                      @click="cliSub(item, index)"
                      :disabled="item.Sub"
                      >-</Button
                    >
                    <input
                      oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                      :id="index"
                      @blur="BlurNumber(item, index)"
                      v-model="item.maxNum"
                      style="width: 53px; text-align: center; line-height: 31px"
                    />
                    <Button
                      style="
                        border: none;
                        border-left: 1px solid #dcdee2;
                        border-radius: 0;
                      "
                      class="number-add"
                      @click="cliAdd(item, index)"
                      :disabled="item.Add"
                      >+</Button
                    >
                  </div>
                  <!-- <InputNumber
                    v-model="item.maxNum"
                    controls-outside
                    :min="item.orderQuantity"
                    :max="item.maxstock"
                    @on-change="changeNum(item, index)"
                    @on-blur="double(item, index)"
                  ></InputNumber> -->
                  <div style="font-size: 1px; margin-top: 5%" v-show="item.latestTime ? !null : false">于{{ item.latestTime }}，购买{{ item.partNum }}{{ item.unitId }}</div>
                </div>
              </Col>
              <Col span="3">
                <div class="handle" v-if="tenantId !== item.tenantId">
                  <div class="left">
                    <span
                      v-if="item.attention == true"
                      class="iconfont icon-a-ziyuan1"
                      title="收藏"
                      @click="getCollect(item)"
                    ></span>

                    <span
                      style="padding-top: 4px"
                      v-else
                      class="iconfont icon-a-lujing157"
                      title="收藏"
                      @click="getCollect(item)"
                    ></span>
                    <div v-if="!item.inquiry" class="regular">
                      <span
                        class="iconfont icon-a-zu420"
                        title="加入购物车"
                        @click="setShopCat(item, index)"
                      ></span>
                    </div>
                    <div v-else class="noregular">
                      <span class="iconfont icon-a-zu420"></span>
                    </div>

                    <xiaopei
                      style="padding-top: 2px"
                      :oppositeTenantId="item.tenantId"
                      :partId="item.partId"
                    >
                      <i class="iconfont icon-a-lujing162"></i>
                    </xiaopei>
                  </div>
                  <div class="right">
                    <Button
                      type="error"
                      v-if="item.inquiry == 0"
                      @click="prebuy(item)"
                      :loading="item.buyLoading"
                      >立即购买</Button
                    >
                    <Button
                      v-if="item.inquiry == 1"
                      type="primary"
                      @click="enquiry(item)"
                      >立即询价</Button
                    >
                  </div>
                </div></Col
              >
            </Row>
          </div>
        </transition-group>
        <!-- 数据为空 -->
        <div class="emptyData" v-if="dataList.length == 0">
          <p>
            <span
              ><i
                ><Icon
                  type="ios-alert-outline"
                  size="17"
                />没找到您想要的数据~</i
              ></span
            >
          </p>
        </div>
        <!-- 加载中 -->
        <div class="demo-spin-container" v-if="spinShow">
          <Spin fix></Spin>
        </div>
      </div>
      <!-- 咨询 -->
      <!-- <partsadvisory ref="partchild"></partsadvisory> -->
      <div style="display: flex; justify-content: right">
        <Page
          :total="pager.total"
          :current="pager.current"
          :page-size="pager.size"
          size="small"
          :page-size-opts="[30]"
          show-total
          @on-change="changeCurrent"
          @on-page-size-change="changeSize"
        />
        <span
          style="
            line-height: 11px;
            height: 26px;
            padding: 7px 10px;
            border: 1px solid #dcdee2;
            border-radius: 3px;
          "
          >30条/页</span
        >
      </div>
    </div>
    <!-- <div class="ceshi">
      <ul>
        <li v-for="item in imgs" :key="item.url">
          <a href="/test">
            <img :src="item.url" alt="" />
          </a>
        </li>
      </ul>
    </div> -->
    <Footer></Footer>
    <FooterP></FooterP>
    <enquirytk
      ref="enquirytkl"
      :enquirydata="enquirydata"
      @enquirysx="enquirysx"
    ></enquirytk>
  </div>
</template>

<script>
import Slider from '../base/common/slider.vue'
import HeaderTop from '../base/common/header-top.vue'
import Footer from '../base/common/footer.vue'
// import HeaderSearch from '../base/common/header-search.vue'
import FooterP from '../base/common/footer-p.vue'
import Searchtop from '../components/searchTop.vue'
import { listData } from '@/views/base/common/listData.js'
// import partsadvisory from './components/partsadvisory.vue'
import xiaopei from '@/views/xiaopei/index.vue'
import enquirytk from '@/views/base/common/enquirytk.vue'
import {
  getDataList,
  getShopByTenantIds,
  getattention,
  getWare
} from '@/api/goodsList.js'

export default {
  mixins: [listData],
  components: {
    Slider,
    HeaderTop,
    Footer,
    // HeaderSearch,
    FooterP,
    Searchtop,
    xiaopei,
    enquirytk
    // partsadvisory
  },
  data() {
    return {
      isCity: '',
      enquirydata: {}, // 询价的数据
      model1: '0',
      hasGoods: false,
      isActive: false,
      emptyData: false,
      key: '', //搜索内容
      cehcekWare: '',
      checkWareId:'', // 仓库id
      warehouseLi: [],
      shopList: [
        {
          id: 0,
          shortName: '全部'
        }
      ],

      searchData: {
        area: 2,
        carBrandName: '',
        current: 1,
        inStock: '',
        keyword: '',
        leagueId: '',
        partType: '',
        priceSort: '', // 价格查询排序,
        shopId: 0,
        size: 30,
        stockSort: '' // 库存查询排序
      }
    }
  },
  created() {
    this.initWare()
    this.getShopByTenantIds()
  },
  methods: {
    checkCITY(i, item) {
      this.isCity = i.name
      item.shipCityStore = i
      item.stock = i.stock
    },
    // 立即询价
    enquiry(item) {
      this.enquirydata = JSON.parse(JSON.stringify(item))
      this.$refs.enquirytkl.enquirytkc()
    },
    // 询价刷新
    enquirysx() {
      this.$refs.shopcar.getenquirydata()
    },
    // 关注
    async getCollect(item) {
      item.attention = !item.attention
      if (item.attention) {
        item.attention = 1
      } else {
        item.attention = 0
      }
      const res = await getattention({
        partId: item.partId,
        attention: item.attention
      })
      if (res.status) {
        if (item.attention == 1) {
          this.$Message.success('关注成功')
        } else {
          this.$Message.error('关注取消')
        }
        return
      } else {
        item.attention = !item.attention
      }
    },
    
    async initWare() {
      let leagueId = JSON.parse(localStorage.getItem('userdetails_leagueInfo')).leagues[0].id
      const val = await getWare({ tenantId: leagueId })

      if (val.status) {
        this.warehouseLi = val.data
        if (this.warehouseLi.length > 0) {
          this.cehcekWare = this.warehouseLi[0].id
          this.cehcekWarename =
              this.warehouseLi[0].value + this.warehouseLi[0].name
        }
        if (this.warehouseLi.length === 2){
          
          this.cehcekWare = this.warehouseLi[1].id
        }
        this.getDataList()
      }
      
    },
    
    // 获取了数据
    async getDataList() {
      this.show = true
      this.spinShow = true
      let data = JSON.parse(JSON.stringify(this.searchData))
      data.shopId = data.shopId == 0 ? '' : data.shopId
      let res = await getDataList(data)
      res.num = 0
      if (res.status == true) {
        this.$nextTick(() => {
          this.brandArr = res.data.partBrandVOList
          this.PartsTypeArr = res.data.partsTypeList
          this.$refs.searchTop.getListBrandType(this.brandArr)
          this.$refs.searchTop.getListPartsType(this.PartsTypeArr)
          this.dataList = res.data.ipage.records
           if (this.cehcekWare) {
            this.dataList.forEach(item => {
              const result = item.shipCityStores.find(store => {
                return store.storeId === this.cehcekWare
              })
              if (result) {
                this.$set(item, 'stock', result.stock)
                this.$set(item, 'shipCityStore', result)
              }
            })
          }


          this.pager.total = res.data.ipage.total
          this.getMaxNum()
        })
      } else {
        this.dataList = []
        this.$refs.searchTop.getListBrandType([])
        this.$refs.searchTop.getListPartsType([])
      }

      this.spinShow = false
    },
    // 获取门店
    async getShopByTenantIds() {
      let res = await getShopByTenantIds()
      this.shopList = [...this.shopList, ...res.data.list]
    },
    // 改变门店
    changeShop() {
      this.changeListsBtn()
    },
    // 搜索配件
    searchSupper() {
      this.searchData.keyword = this.key.trim()
      this.searchData.current = 1
      this.searchData.size = 10
      ;(this.pager = {
        current: 1,
        total: 0,
        size: 30
      }),
        // this.pager.current = 1
        // this.pager.size = 10
        this.getDataList()
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';

.ellipsis {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px; /* 根据需要调整最大宽度 */
}

.ceshi {
  display: block;
  clear: both;
  content: '';
  // ul {
  //   width: 1200px;
  //   margin: 0 auto;
  //   // display: flex;
  //   li {
  //     float: left;
  //     width: 10%;
  //     border: 1px solid;
  //     // flex: 1;
  //     img {
  //       // width: 120px;
  //       width: 100%;
  //     }
  //   }
  // }
}
</style>
